import AmioHttpService from './amio-http.service'

class TemplateService extends AmioHttpService {

  list(botId) {
    return this.requestGet(`/bots/${botId}/templates`)
      .then(response => response.data)
      .then(templates => templates.map(adapt))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  listRefs(botId, templateId) {
    return this.requestGet(`/bots/${botId}/templates/${templateId}/references`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
  get(botId, templateId) {
    return this.requestGet(`/bots/${botId}/templates/${templateId}`)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getReferencedConversations(botId, templateId) {
    return this.requestGet(`/bots/${botId}/templates/${templateId}/referenced-conversations`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  create(botId, name, conversationJson, variableRefs, answerRefs) {
    return this.requestPost(`/bots/${botId}/templates`, {
      name,
      conversation_json: conversationJson,
      variable_refs: variableRefs,
      answer_refs: answerRefs
    })
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  update(botId, templateId, patchData) {
    return this.requestPatch(`/bots/${botId}/templates/${templateId}`, patchData)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  delete(botId, templateId) {
    return this.requestDelete(`/bots/${botId}/templates/${templateId}`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

function adapt(template) {
  return {
    id: template.id,
    botId: template.bot_id,
    name: template.name,
    conversationJson: template.conversation_json,
    conversationJsonHash: template.conversation_json_hash
  }
}

export default new TemplateService()
